export const QUOTE_BUTTON_GROUP = {
  key: "quoteButton",
  label: "Customize Action Button",
  description:
    "Controls the quote button in the desktop header, mobile bottom nav, and below the mobile homepage slider.",
  fields: [
    {
      key: "quoteButtonDesktopText",
      type: "text",
      label: "Desktop Button Text",
      default: "Customize Quote",
    },
    {
      key: "quoteButtonMobileText",
      type: "text",
      label: "Mobile Button Text",
      default: "Customize your quote",
    },
    {
      key: "quoteButtonLink",
      type: "text",
      label: "Button Link (e.g. /quote or https://example.com)",
      default: "/quote",
    },
  ],
};

export const QUOTE_BUTTON_DEFAULTS = {
  quoteButtonDesktopText: "Customize Quote",
  quoteButtonMobileText: "Customize your quote",
  quoteButtonLink: "/quote",
};

export function mergeQuoteButtonSchema(schema = {}) {
  const groups = [...(schema.groups || [])];
  if (!groups.some((group) => group.key === "quoteButton")) {
    const featuresIndex = groups.findIndex((group) => group.key === "features");
    if (featuresIndex >= 0) {
      groups.splice(featuresIndex, 0, QUOTE_BUTTON_GROUP);
    } else {
      groups.push(QUOTE_BUTTON_GROUP);
    }
  }
  return { ...schema, groups };
}

export function withQuoteButtonDefaults(settings = {}) {
  return { ...QUOTE_BUTTON_DEFAULTS, ...settings };
}

export function pickQuoteButtonSettings(settings = {}) {
  return QUOTE_BUTTON_GROUP.fields.reduce((acc, field) => {
    const value = settings[field.key];
    if (value !== undefined && value !== null) {
      acc[field.key] = value;
    }
    return acc;
  }, {});
}
